import { FileText, Download, Trash2 } from "lucide-react";

export const PdfFileRow = ({ file, onDelete, apiUrl }) => {
  const handleDownload = () => {
    window.open(`${apiUrl}/files/${file.id}/download`, '_blank');
  };

  return (
    <div className="file-row group" data-testid="pdf-file-row">
      <div className="flex items-center gap-3 min-w-0 flex-1">
        <div className="flex-shrink-0 p-2 rounded-lg bg-red-50">
          <FileText size={18} className="text-red-500" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-gray-800 truncate">
            {file.original_name}
          </p>
          <p className="text-xs font-mono text-gray-400 mt-0.5" data-testid="pdf-file-size-label">
            {file.size_label}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <button
          onClick={handleDownload}
          className="btn-press flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium text-blue-600 hover:bg-blue-50"
          style={{ transition: 'background-color 0.12s ease' }}
          data-testid="pdf-file-download-button"
        >
          <Download size={14} />
          <span className="hidden sm:inline">Muat turun</span>
        </button>
        {onDelete && (
          <button
            onClick={() => {
              if (window.confirm('Padam fail ini?')) {
                onDelete(file.id);
              }
            }}
            className="btn-press p-1.5 rounded-lg text-gray-300 hover:text-red-500 hover:bg-red-50 opacity-0 group-hover:opacity-100"
            style={{ transition: 'opacity 0.12s ease, background-color 0.12s ease, color 0.12s ease' }}
            data-testid="pdf-file-delete-button"
          >
            <Trash2 size={14} />
          </button>
        )}
      </div>
    </div>
  );
};
